<template>
  <div class="digital-lecture-detail-video-synopsis">
    <h2 class="title">Краткий конспект видео</h2>
    <div v-sane-html="content" class="content" />
  </div>
</template>

<script lang="ts" setup>
  defineProps<{
    content: string
  }>()
</script>

<style lang="scss" scoped>
  .digital-lecture-detail-video-synopsis {
    @extend %flex-column;

    gap: 24px;
    padding: 32px;
    border-radius: 32px;
    background-color: $color-default-white;

    @include vp-1279 {
      border-radius: 24px;
    }

    @include vp-767 {
      padding: 24px 16px;
    }

    > .title {
      font-size: 28px;
      font-weight: 500;
      line-height: 36px;
      margin: 0;

      @include vp-767 {
        font-size: 20px;
        line-height: 28px;
      }
    }

    > .content {
      font-size: 16px;
      line-height: 24px;
      overflow-wrap: break-word;

      :deep(a) {
        color: $color-kiwi-50;
        text-decoration: underline;
      }

      :deep(iframe) {
        width: 100%;
      }

      :deep(img) {
        width: 100% !important;
        height: auto !important;
        border-radius: 32px;

        @include vp-1279 {
          border-radius: 24px;
        }
      }

      :deep(ul) {
        list-style: none;
        @extend %flex-column;

        gap: 12px;
        padding: 16px;

        > li {
          position: relative;
          padding-left: 36px;
          font-size: 16px;
          line-height: 24px;

          &::before {
            position: absolute;
            content: '';
            top: calc(50% - 2px);
            left: 2px;
            width: 6px;
            height: 6px;
            background-color: $color-banana-70;
            border-radius: 50%;
          }
        }
      }

      :deep(ol) {
        list-style-position: inside;
        @extend %flex-column;

        gap: 12px;
        padding: 16px;

        > li {
          font-size: 16px;
          line-height: 24px;
        }
      }

      :deep(blockquote) {
        position: relative;
        margin: 0;
        padding: 16px 16px 16px 52px;
        font-size: 16px;
        line-height: 24px;
        color: $color-potato-90;
      }

      :deep(table) {
        width: 100% !important;
        border-collapse: collapse;
        margin: 16px 0;
        font-size: 16px;
        line-height: 24px;
        background-color: $color-default-white;
        border-radius: 8px;
        overflow: hidden;

        @include vp-767 {
          font-size: 14px;
          line-height: 22px;
          margin: 12px 0;
        }

        td,
        th {
          padding: 12px 16px;
          border: 1px solid $color-potato-20;
          text-align: left;
          vertical-align: top;
          overflow-wrap: break-word;

          @include vp-767 {
            padding: 8px 12px;
          }
        }

        th {
          background-color: $color-potato-10;
        }
      }
    }
  }
</style>
